const getQueryParam = name => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
};
export default getQueryParam;
